import { useState } from "react";
import WizardNavigation from "../WizardNavigation";
import StepHeader from "../StepHeader";

const EXTRAS = [
  {
    value: "props",
    label: "Requisiten",
    description: "Lustige Props & Accessoires",
  },
  {
    value: "liveview",
    label: "Live-View",
    description: "Gäste sehen sich auf dem Bildschirm",
  },
];

export default function StepExtras({ value = [], onNext, onBack }) {
  const [localValue, setLocalValue] = useState(value);

  const handleToggle = (extra) => {
    const updated = localValue.includes(extra)
      ? localValue.filter((e) => e !== extra)
      : [...localValue, extra];
    setLocalValue(updated);
  };

  const handleNext = () => {
    onNext({ extras: localValue });
  };

  return (
    <div className="space-y-6">
      <StepHeader
        title="Möchtest du Extras hinzufügen?"
        description="Optional – du kannst diesen Schritt auch überspringen."
      />

      <div className="space-y-3">
        {EXTRAS.map((extra) => (
          <button
            key={extra.value}
            onClick={() => handleToggle(extra.value)}
            className={`w-full p-4 rounded-lg border-2 transition text-left ${
              localValue.includes(extra.value)
                ? "border-[#FF5744] bg-[#FFF4F0]"
                : "border-slate-200 bg-white hover:border-slate-300"
            }`}
          >
            <div className="flex items-start gap-3">
              <div
                className={`w-5 h-5 rounded border-2 flex items-center justify-center flex-shrink-0 mt-0.5 ${
                  localValue.includes(extra.value)
                    ? "bg-[#FF5744] border-[#FF5744]"
                    : "border-slate-300"
                }`}
              >
                {localValue.includes(extra.value) && (
                  <span className="text-white text-xs">✓</span>
                )}
              </div>
              <div className="flex-1">
                <div className="font-semibold text-slate-900">
                  {extra.label}
                </div>
                <div className="text-sm text-slate-600">
                  {extra.description}
                </div>
              </div>
            </div>
          </button>
        ))}
      </div>

      <WizardNavigation onBack={onBack} onNext={handleNext} />
    </div>
  );
}
